(() => {
  /** @param {HTMLElement} section */
  const initSpirit = (section) => {
    const track = section.querySelector('[data-spirit-track]');
    const previous = section.querySelector('[data-spirit-prev]');
    const next = section.querySelector('[data-spirit-next]');
    if (!(track instanceof HTMLElement) || !(previous instanceof HTMLButtonElement) || !(next instanceof HTMLButtonElement)) return;

    const update = () => {
      previous.disabled = track.scrollLeft <= 5;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 5;
    };

    /** @param {number} direction */
    const move = (direction) => {
      const card = track.querySelector('.rver-spirit-card');
      if (!(card instanceof HTMLElement)) return;
      const gap = Number.parseFloat(getComputedStyle(track).gap) || 8;
      track.scrollBy({ left: direction * (card.offsetWidth + gap), behavior: 'smooth' });
    };

    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  };

  const init = () => document.querySelectorAll('[data-rver-spirit]').forEach((section) => {
    if (section instanceof HTMLElement) initSpirit(section);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLElement)) return;
    const section = target.querySelector('[data-rver-spirit]');
    if (section instanceof HTMLElement) initSpirit(section);
  });
})();
